export default __webpack_public_path__ + "static/media/11.f040c6b2.svg";